import { createContext, useContext } from 'react';
import type React from 'react';

export interface KeyboardContextValue {
  keyboardVisible: boolean;
  focusedElement: HTMLInputElement | HTMLTextAreaElement | null;
  hideKeyboard: () => void;
  isPasswordField: boolean;
  setIsPasswordField: (val: boolean) => void;
  passwordSetter?: React.Dispatch<React.SetStateAction<string>>;
  setPasswordSetter: (
    fn: React.Dispatch<React.SetStateAction<string>> | undefined
  ) => void;
}

export const KeyboardContext = createContext<KeyboardContextValue | undefined>(
  undefined
);

export const useKeyboardContext = () => {
  const ctx = useContext(KeyboardContext);
  if (!ctx) {
    throw new Error('useKeyboardContext must be used within a KeyboardProvider');
  }
  return ctx;
};
